"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomStandaloneTestT = exports.standaloneTestT = exports.makeTransComponent = exports.withTranslationGeneric = exports.useTranslationGeneric = exports.formatters = exports.useErrorTranslation = exports.LocalisableGraphQLError = exports.useApolloErrorTranslation = exports.useServerMessageTranslation = exports.ForcedLocaleProvider = exports.TranslationProvider = void 0;
// eslint-disable-next-line import/no-named-as-default
var i18next_1 = __importDefault(require("i18next"));
var i18next_formatters_1 = require("@equiem/i18next-formatters");
var initializeFrontendReact_1 = require("./lib/initializeFrontendReact");
var config_1 = require("./lib/config");
// IMPORTANT:
//
// Initialize the global i18n instance with EQ1 config, minus site/profile locale
// preferences. This is essential for us to be able to use localisation
// functions in react-ui without breaking un-localised front-ends, e.g. web-ng.
//
// This must be done as early as possible.
var globalInstance = (0, initializeFrontendReact_1.initialize)({
    instance: i18next_1.default,
    localePreferenceScope: {},
    gqlRequester: null,
}).instance;
var TranslationProvider_1 = require("./components/TranslationProvider");
Object.defineProperty(exports, "TranslationProvider", { enumerable: true, get: function () { return TranslationProvider_1.TranslationProvider; } });
var ForcedLocaleProvider_1 = require("./components/ForcedLocaleProvider");
Object.defineProperty(exports, "ForcedLocaleProvider", { enumerable: true, get: function () { return ForcedLocaleProvider_1.ForcedLocaleProvider; } });
var useServerMessageTranslation_1 = require("./lib/useServerMessageTranslation");
Object.defineProperty(exports, "useServerMessageTranslation", { enumerable: true, get: function () { return useServerMessageTranslation_1.useServerMessageTranslation; } });
var useApolloErrorTranslation_1 = require("./lib/useApolloErrorTranslation");
Object.defineProperty(exports, "useApolloErrorTranslation", { enumerable: true, get: function () { return useApolloErrorTranslation_1.useApolloErrorTranslation; } });
var LocalisableError_1 = require("./lib/LocalisableError");
Object.defineProperty(exports, "LocalisableGraphQLError", { enumerable: true, get: function () { return LocalisableError_1.LocalisableGraphQLError; } });
var useErrorTranslation_1 = require("./lib/useErrorTranslation");
Object.defineProperty(exports, "useErrorTranslation", { enumerable: true, get: function () { return useErrorTranslation_1.useErrorTranslation; } });
exports.formatters = (0, i18next_formatters_1.getFormatters)(globalInstance);
var useTranslation_1 = require("./wrappers/useTranslation");
Object.defineProperty(exports, "useTranslationGeneric", { enumerable: true, get: function () { return useTranslation_1.useTranslationGeneric; } });
var withTranslation_1 = require("./wrappers/withTranslation");
Object.defineProperty(exports, "withTranslationGeneric", { enumerable: true, get: function () { return withTranslation_1.withTranslationGeneric; } });
var Trans_1 = require("./wrappers/Trans");
Object.defineProperty(exports, "makeTransComponent", { enumerable: true, get: function () { return Trans_1.makeTransComponent; } });
/** WARNING: Do not use in production code! For use in Cypress tests only. */
exports.standaloneTestT = globalInstance.getFixedT(config_1.defaultLocale);
/** WARNING: Do not use in production code! For use in Cypress tests only. */
var getCustomStandaloneTestT_1 = require("./lib/getCustomStandaloneTestT");
Object.defineProperty(exports, "getCustomStandaloneTestT", { enumerable: true, get: function () { return getCustomStandaloneTestT_1.getCustomStandaloneTestT; } });
